import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "el-form-w2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_slider_input = _resolveComponent("slider-input");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_form_item = _resolveComponent("el-form-item");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_slider_input, {
    title: "比例",
    showPX: false,
    max: 10,
    size: $data.scale,
    onInput: _cache[0] || (_cache[0] = $event => $options.inputChange($event, 'scale'))
  }, null, 8, ["size"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form_item, null, {
    label: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createElementVNode("span", null, "X", -1)]))]),
    default: _withCtx(() => [_createVNode(_component_el_input_number, {
      modelValue: $data.anchorx,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.anchorx = $event),
      min: -10,
      max: 10,
      "controls-position": "right",
      onInput: _cache[2] || (_cache[2] = $event => $options.inputChange($event, 'anchorx'))
    }, null, 8, ["modelValue"])]),
    _: 1
  }), _createVNode(_component_el_form_item, null, {
    label: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createElementVNode("span", null, "Y", -1)]))]),
    default: _withCtx(() => [_createVNode(_component_el_input_number, {
      modelValue: $data.anchory,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.anchory = $event),
      min: -10,
      max: 10,
      "controls-position": "right",
      onInput: _cache[4] || (_cache[4] = $event => $options.inputChange($event, 'anchory'))
    }, null, 8, ["modelValue"])]),
    _: 1
  })])]);
}